import SleepReportModule from './SleepReportModule'

export default SleepReportModule
